import React from 'react'

const SalesCadentierFormatorSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.538452" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17859)" />
    <path
      d="M44.558 21.2667H40.9698C40.1463 18.7961 37.7933 17.0314 35.0286 17.0314C32.2639 17.0314 29.911 18.7961 29.0286 21.2667H25.4404C23.6757 21.2667 22.2639 22.6785 22.2639 24.4432V47.8549C22.2639 49.6196 23.6757 51.0314 25.4404 51.0314H44.558C46.3227 51.0314 47.7345 49.6196 47.7345 47.8549V24.4432C47.7933 22.7373 46.3227 21.2667 44.558 21.2667ZM35.0286 21.2667C36.2051 21.2667 37.1463 22.2079 37.1463 23.3844C37.1463 24.5608 36.2051 25.502 35.0286 25.502C33.8522 25.502 32.911 24.5608 32.911 23.3844C32.911 22.2079 33.8522 21.2667 35.0286 21.2667ZM41.0874 34.502L35.2051 41.9138C34.911 42.2667 34.558 42.502 34.0874 42.502C34.0286 42.4432 33.9698 42.502 33.911 42.502C33.558 42.502 33.1463 42.3844 32.8522 42.0902L29.1463 38.9138C28.4992 38.3255 28.3816 37.3255 28.9698 36.6785C29.558 36.0314 30.558 35.9138 31.2051 36.502L33.6757 38.6196L38.4992 32.502C39.0286 31.7961 40.0286 31.6785 40.7345 32.2079C41.4992 32.7961 41.6169 33.7961 41.0874 34.502Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17859"
        x1="34.5455"
        y1="0.538452"
        x2="34.5455"
        y2="70.5385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07888D" />
        <stop offset="1" stopColor="#006064" />
      </linearGradient>
    </defs>
  </svg>
)

export default SalesCadentierFormatorSubcategory
